<div class="flex flex-col flex-start-stretch gap-12">
  <div
    (fileDropped)="filesDropped($event)"
    class="files-upload-container flex flex-col flex-center-center"
    dragAndDropFile
  >
    <div class="typography-paragraph files-upload-upload-text flex flex-col flex-center-center">
      <div class="flex flex-col flex-center-center max-md:hidden">
        <span>{{ mainDescription }}</span>
        <span class="files-upload-upload-text-button">
          <input #filesUploadButton class="file-input" multiple type="file" />
          <span>{{ secondaryDescription }}</span>
          <button
            [ngClass]="{ 'small-button': (mediaQueryService.breakpoints$ | async).ltMd }"
            (click)="filesUploadButton.click()"
            color="primary"
            mat-button
            type="button"
          >
            {{ filesUploadButtonLabel }}
          </button>
        </span>
      </div>
      <div class="flex flex-col flex-center-center max-sm:gap-6 gap-12 md:hidden">
        <img
          (click)="filesUploadButton.click()"
          class="files-upload-upload-img"
          src="/assets/my7n-ui/icons/photo_upload.svg"
        />
        <button (click)="filesUploadButton.click()" color="primary" mat-button type="button">Add files</button>
      </div>
    </div>
  </div>
  @if (files.length > 0) {
    <div class="files-list form-group flex flex-col flex-start-start">
      <mat-label>Added files</mat-label>
      <div class="files-list-container">
        @for (file of files; track file; let idx = $index) {
          <files-upload-element
            [controlErrorObject]="controlErrorObject"
            [currentValidationMessage]="currentValidationMessage"
            [file]="file"
            [index]="idx"
            (removeFile)="removeFile($event)"
          ></files-upload-element>
        }
      </div>
    </div>
  }
</div>
